export default __webpack_public_path__ + "static/affiliatesBannerBg-9549d71b0d6120131ccc4a320d7fe4fe.png";